export const SAM_STATUS_POLLING_INTERVAL_COMPLETED = 30000;
export const SAM_STATUS_POLLING_INTERVAL_NOT_COMPLETE = 10000;
export const SAM_STATUS_POLLING_PREDELAY = 3000;
export const SAM_POWER_USER_UP = 'samPowerUserUp';
export const SAM_SUPER_USER_UP = 'samSuperUserUp';
export const MAX_STUDENT_UIN_COUNT_LIMIT = 1000;
